<template>
    <ul v-if="events.length != 0" class="flex flex-wrap w-full">
        <li v-for="event in events" :key="event.id" class="w-full px-3 py-2 md:w-3/12">
            <div class="relative mb-4 bg-white shadow-md rounded-2xl hover:shadow-xl">
                <a :href="`/event/${event.slug}`">
                    <img v-if="!event.cover" src="/assets/event.jpg" :alt="event.title" class="w-full rounded-t-2xl">
                    <img v-else :src="event.cover" :alt="event.title" class="w-full rounded-t-2xl">
                    <div v-if="event.virtual == true" class="absolute px-3 py-1 bg-purple-500 rounded-r shadow-md top-2 -right-1">
                        <span class="text-sm font-semibold text-white uppercase">online</span>
                    </div>
                    <div v-if="event.type == 1" :class="event.virtual == true ? 'top-12' : 'top-2' " class="absolute flex items-center px-3 py-1 bg-green-600 rounded-r shadow-md -right-1">
                        
                        <span class="text-sm font-semibold text-white uppercase">
                            GRATUITO</span>
                    </div>
                    <div v-if="event.type == 2" :class="event.virtual == true ? 'top-12' : 'top-2' " class="absolute flex items-center px-3 py-1 bg-red-600 rounded-r shadow-md -right-1">
                        <img src="/assets/icons/crown.png" alt="premium" class="w-6 mr-1">
                        <span class="text-sm font-semibold text-white uppercase">
                            A PAGAMENTO</span>
                    </div>
                    <ul v-if="event.mainspeaker != null" class="px-6 text-sm text-gray-500">
                        <li>
                            <div class="relative flex w-full mb-2">
                                <div class="absolute w-12 h-12 bg-center bg-cover border-2 border-white border-solid rounded-full shadow-lg -top-4 hover:shadow-xl" :style="`background-image: url('${event.mainspeaker.portrait}')`"></div>
                                <div class="py-3 pl-16">{{event.mainspeaker.name}} {{ event.mainspeaker.last_name }}</div>
                            </div>    
                        </li>
                    </ul>
                    <ul v-else class="px-6 text-sm text-gray-500">
                        <li v-for="(speaker, index) in event.thespeakers" :key="speaker.id">
                            <div v-if="index <= 0"  class="relative flex w-full mb-2">
                                <div class="absolute w-12 h-12 bg-center bg-cover border-2 border-white border-solid rounded-full shadow-lg -top-4 hover:shadow-xl" :style="`background-image: url('${speaker.portrait}')`"></div>
                                <div class="py-3 pl-16">{{speaker.name}} {{ speaker.last_name }}</div>
                            </div>
                        </li>
                    </ul>
                    <div class="flex flex-col justify-between px-6 pb-6 event-card">
                        <div>
                            <h4 class="w-full my-1 text-lg font-bold">{{ event.title }}</h4>
                            <div class="text-sm text-gray-500">
                                <span class="inline-block font-semibold text-left text-pink-600">{{ event.date +" "+ event.start_time | moment("DD-MM-YYYY") }}<span class="ml-4 font-bold text-black"> ore: </span>{{ event.date +" "+ event.start_time | moment("HH:mm") }}</span>
                            </div>
                            <p class="py-2 text-sm text-gray-700">{{ event.excerpt | truncate(250, '...')}}</p>
                        </div>
                        <div v-if="!event.virtual" class="flex">
                            <span class="py-1 pr-2 text-sm font-bold text-gray-900 capitalize">{{ event.city }}</span>
                            <span v-if="event.place" class="py-1 text-sm font-light text-gray-500">{{ event.place }}</span>
                            <span v-else class="py-1 text-sm font-light text-gray-500">Location in definizione</span>
                        </div>
                        <div v-if="event.virtual" class="flex">
                            <span class="py-1 pr-2 text-sm font-bold text-purple-600">Evento online</span>
                        </div>        
                    </div>
                </a>
            </div>
        </li>
    </ul>
    <ul v-else>
        <div class="grid py-20 text-lg font-extrabold text-center">
            NO EVENTS FOUND
            <i class="material-icons" style="font-size:36px">sentiment_very_dissatisfied</i>
        </div>
    </ul>
</template>

<script>
    export default {
        props: [
            'events',
            'speakers',
        ],
        data() {
            return {
                length: 0,
            };
        },
        filters: {
            truncate: function(text, length, clamp){
                clamp = clamp || '...';
                var node = document.createElement('div');
                node.innerHTML = text;
                var content = node.textContent;
                return content.length > length ? content.slice(0, length) + clamp : content;
            }
        }   
    }

</script>